<template>
  <div
    class="samsung-update-view"
    :class="[{ 'golf-update-view': isGolfService }]"
  >
    <button ref="closeBtn" class="close-btn" @click.prevent="close">
      앱을 종료합니다
    </button>
    <iframe :src="d_url"></iframe>
  </div>
</template>

<script>
import * as deviceApi from "../api/smartTv.js";
import { isGolf } from "@/utils/common";

export default {
  props: ["d_url"],
  data() {
    return {
      focusIndex: 0,
      isActiveVue: true,
      isGolfService: isGolf,
    };
  },
  mounted() {},
  computed: {
    keyInput() {
      return this.$store.getters.keyInput;
    },
  },
  watch: {
    keyInput(val, oldVal) {
      if (this.isActiveVue) {
        switch (val.key) {
          case "ArrowUp":
          case "ArrowDown":
          case "ArrowRight":
            break;
          case "Enter":
            this.close();
            break;
          case "Backspace":
            this.close();
            break;
        }
      }
    },
  },
  methods: {
    close() {
      deviceApi.stopApplication();
    },
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style lang="less" scoped>
.samsung-update-view {
  width: 100%;

  .close-btn {
    position: absolute;
    background: #2affcc;
    width: 200px;
    height: 60px;
    top: 30px;
    right: 30px;
    z-index: 100;
    border-radius: 10px;
    font-weight: bold;
    font-size: 20px;
    border: solid 4px #eeeeee;

    &:focus,
    &:hover {
      outline: solid 4px #eeeeee;
    }
  }

  iframe {
    width: 100vw;
    height: 100vh;
    border: 0;
  }

  .golf-update-view {
    .close-btn {
      background: #ff4600;
      color: #ffffff;
    }
  }
}
</style>
